if (!customElements.get('wb-private-downloads-popup')) {
  customElements.define(
    'wb-private-downloads-popup',
    class WbPrivateDownloadsPopup extends HTMLElement {
      connectedCallback() {
        this.closeElements = this.querySelectorAll('.js-close');

        this.initEvents();
      }

      initEvents() {
        this.closeElements.forEach(el => el.addEventListener('click', this.hide.bind(this)));

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.hide();
          }
        });
      }

      show() {
        this.classList.add('wb-private-downloads-popup--show');
      }

      hide() {
        this.classList.remove('wb-private-downloads-popup--show');

        this.dispatchEvent(new CustomEvent('wb_popup_close'));
      }
    },
  );
}

if (!customElements.get('wb-private-downloads-teaser')) {
  customElements.define(
    'wb-private-downloads-teaser',
    class WbPrivateDownloadsTeaser extends HTMLElement {
      connectedCallback() {
      }

      show() {
        this.classList.add('wb-private-downloads-teaser--show');
      }

      hide() {
        this.classList.remove('wb-private-downloads-teaser--show');
      }
    },
  );
}

(function () {
  const PDL_TOKEN = "F7X9-RT3P-Q84M-JK2D";
  const PDL_TOKEN_QUERY_KEY = "pdl_token";
  const PDL_TOKEN_STORAGE_KEY = "pdl_token_stored";

  class PrivateDownloadsPopup {
    constructor() {
      this.customerAcceptsMarketing = this.initAcceptsMarketingState()
      this.isAlreadyConversioned = this.initIsAlreadyConversioned()
      this.hasValidToken = this.initHasValidToken()
      this.isAlreadySubscribed = this.initIsAlreadySubscribed();
      this.teaserElement = document.querySelector('#wbPrivateDownloadsTeaser');
      this.thankYouPopupElement = document.querySelector('#wbPrivateDownloadsThankYouPopup');

      this.initDownloadLinks();
      this.initTeaserElement();
      this.initEvents();
    }

    initAcceptsMarketingState() {
      return window.wbPrivateDownloadsPopup.customerAcceptsMarketing === true;
    }

    initDownloadLinks() {
      if (this.isAlreadySubscribed) {
        this.showDownloadLinks();
      }
    }

    initTeaserElement() {
      if (!this.teaserElement) {
        return;
      }

      if (this.customerAcceptsMarketing || this.isAlreadyConversioned) {
        return this.teaserElement.remove();
      }

      document.body.appendChild(this.teaserElement);
      this.teaserElement.show();
    }

    initEvents() {
      this.thankYouPopupElement.addEventListener('wb_popup_close', this.onThankYouPopupClose.bind(this));
    }

    onSubmit() {
      this.thankYouPopupElement.show();
      this.teaserElement?.hide();
    }

    onThankYouPopupClose() {
      // this.scrollToFirstDownloadLink();
    }

    showDownloadLinks() {
      const elements = document.querySelectorAll(".js-private-download-links");

      [...elements].map((el) => (el.style.display = "block"));
    }

    scrollToFirstDownloadLink() {
      this.scrollToElement(
        document.querySelector(".js-private-download-links")
      );
    }

    scrollToElement(element) {
      if (!element) {
        return;
      }

      const announcementBarEl = document.querySelector(
        "#shopify-section-announcement-bar"
      );
      const headerEl = document.querySelector("#shopify-section-header");

      const newOffset =
        54 + (announcementBarEl?.offsetHeight || 0) + (headerEl?.offsetHeight || 0);

      window.scrollTo({
        top: element.offsetTop - newOffset,
        behavior: "smooth",
      });
    }

    initIsAlreadyConversioned() {
      if (typeof window.localStorage !== 'undefined') {
        for (const key in localStorage) {
          if (key.endsWith("_conversioned")) {
            return true
          }
        }
      }

      return false
    }

    initIsAlreadySubscribed() {
      if (this.customerAcceptsMarketing) {
        return true;
      }

      return this.isAlreadyConversioned && this.hasValidToken;
    }

    initHasValidToken() {
      if (typeof window.localStorage === 'undefined') {
        return false
      }

      const params = new URLSearchParams(window.location.search);
      const tokenFromUrl = params.get(PDL_TOKEN_QUERY_KEY) ?? '';

      if (tokenFromUrl.trim() === PDL_TOKEN) {
        localStorage.setItem(PDL_TOKEN_STORAGE_KEY, tokenFromUrl);
        return true;
      }

      return localStorage.getItem(PDL_TOKEN_STORAGE_KEY) === PDL_TOKEN;
    }
  }

  const privateDownloadsPopup = new PrivateDownloadsPopup();

  window.wbPrivateDownloadsPopupSubmit = function () {
    privateDownloadsPopup.onSubmit();
  };
})();